import { TournamentEvent } from '@img-arena/consoles-api-streaming'
import FileDownloadDoneIcon from '@mui/icons-material/FileDownloadDone'
import { formatDate } from '@/utils/dateFormat/dateFormat'

import { Column, COLUMN_CELL_TYPE, Filter } from '../table/base'
import { DetailedCell } from '../table/base/TableBase/components/DetailedCell'
import { formatEventQualifier } from './utils'

export const TOURNAMENT_DETAILS_COLUMNS: Column<TournamentEvent>[] = [
  {
    id: '$isImported',
    label: 'Imported',
    type: COLUMN_CELL_TYPE.COMPONENT,
    render: (value) => (value.exchangeEventId ? <FileDownloadDoneIcon sx={{ ml: 2 }} /> : null),
    sx: { width: 100 }
  },
  {
    id: '$name',
    label: 'Name',
    type: COLUMN_CELL_TYPE.COMPONENT,
    render: (value) => <DetailedCell value={value.name} subValue={`Match Feed ID: ${value.id}`} />,
    comparator: (a, b) => a.name.localeCompare(b.name),
    sx: { width: 600 },
    sortAttribute: '$name'
  },
  {
    id: 'startDate',
    label: 'Start Time',
    type: COLUMN_CELL_TYPE.COMPONENT,
    render: (value) => {
      const { time, fullDate } = formatDate(value)

      return <DetailedCell value={time} subValue={fullDate} />
    },
    comparator: (a, b) => Number(new Date(a)) - Number(new Date(b)),
    sx: { width: 200 }
  },
  {
    id: 'id',
    label: 'Qualifier',
    type: COLUMN_CELL_TYPE.TEXT,
    transform: formatEventQualifier,
    noDataFallback: '',
    sx: { width: 250 }
  },
  {
    id: 'court',
    label: 'Court',
    type: COLUMN_CELL_TYPE.TEXT,
    noDataFallback: ''
  }
]

export const TOURNAMENT_DETAILS_FILTERS: Filter<TournamentEvent>[] = [
  {
    type: 'freeTextSearch',
    paramName: 'name',
    placeholder: 'Search',
    filterOptions: (item, value) => {
      return item.name.toLowerCase().includes(value.toLocaleLowerCase()) || item.id.includes(value)
    },
    width: 200
  }
]
